<template>
    <section class="o-page-bottom-spacing">

        <page-header>
            <slot slot="title">{{ $t('preorder_overview.page_title') }}</slot>
            <slot slot="description">
                <p>{{ $t('intro.customer_preOrders') }}</p>
            </slot>
        </page-header>

        <!-- preorders -->
        <v-overview-list
                data-table="PreOrders"
                btnViewPath="CustomerPreOrdersEdit"
                filter-theme="white"
                :table-columns="PreOrders.columns"
                :btnCopy="false"
                :page-size="99"
                prefix="lop"
                @dataLoaded="notifyUser">

            <template slot="placeholderButtons">
                <router-link class="c-button c-button--icon c-button--alpha u-flex--push-left" to="/salesman/pre-orders/create">
                    <svgicon name="added"></svgicon>
                    <span>{{ $t('preorder_overview.assign_new') }}</span>
                </router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VFilters from '@/components/form/filters/Filters'
    import VPagination from '@/components/Pagination'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VFilters,
            VPagination,
            VSelect,
            VOverviewList
        },
        data() {
            return {}
        },
        computed: {
            PreOrders() {
                return {
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name') },
                        { value: 'InternalCustomerReference', name: this.$t('preorder_overview.columns.internal_customer_ref') },
                        { value: 'LastUpdate', name: this.$t('preorder_overview.columns.last_update'), type: 'Date' },
                        { value: 'SalesMan', name: this.$t('preorder_overview.columns.salesman') },
                        { value: 'HasUnReadMessages', name: this.$t('preorder_overview.columns.messages'), type: 'Message'},
                        { value: 'CustomerState', name: this.$t('preorder_overview.columns.state') }
                    ]
                };
            }
        },
        methods: {
            notifyUser(tableData){
                if (tableData.length) {
                    return;
                }
                
                this.$notify({
                    group: 'global',
                    title: this.$t('preorder_overview.contact_salesman'),
                    type: 'info',
                    duration: -1
                });
              
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/customer/preOrders/Overview.vue